import { NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Fitter, LocationData } from '@sc/data-access-models';
import { IconComponent } from '@sc/ui-components';

@Component({
  selector: 'sc-map-apps',
  styleUrls: ['./map-apps.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, NgIf, TranslateModule],
  template: `
    <div class="content-wrapper">
      <div class="content without-validation-button">
        <section class="without-divider">
          <div class="link" (click)="launchGoogleMap()">
            <sc-icon name="google_map"></sc-icon>
            <span>{{ 'MapApps.googleMapLink' | translate }}</span>
          </div>
        </section>

        <section class="without-divider">
          <div class="link" (click)="launchWaze()">
            <sc-icon name="waze"></sc-icon>
            <span>{{ 'MapApps.wazeMapLink' | translate }}</span>
          </div>
        </section>

        <section class="without-divider" *ngIf="isIOS()">
          <div class="link" (click)="launchAppleMap()">
            <sc-icon name="apple_map"></sc-icon>
            <span>{{ 'MapApps.appleMapLink' | translate }}</span>
          </div>
        </section>
      </div>
    </div>
  `,
})
export class MapAppsComponent {
  @Input() fitter: Fitter;
  @Input() userAddress: LocationData;

  launchGoogleMap(): void {
    const { userAddress, fitter } = this;
    const query = '?saddr=' + userAddress.address + '&daddr=' + fitter.address;

    if (this.isIOS()) {
      window.open('https://maps.google.com/' + query);
    } else {
      window.open('https://maps.google.com/maps' + query);
    }
  }

  launchWaze(): void {
    const { fitter } = this;
    const query = '?ll=' + fitter.location.lat + ',' + fitter.location.lon;

    window.open('https://waze.com/ul' + query);
  }

  launchAppleMap(): void {
    const { userAddress, fitter } = this;
    const query = '?saddr=' + userAddress.address + '&daddr=' + fitter.address;

    window.open('http://maps.apple.com/' + query);
  }

  isAndroid(): boolean {
    if (!navigator.platform) {
      return navigator.userAgent.toLowerCase().indexOf('android') > -1;
    }

    return navigator.platform === 'Android';
  }

  isIOS(): boolean {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod',
    ].includes(navigator.platform);
  }
}
